import React from 'react';
import styled, { css } from 'styled-components';

interface ComponentProps extends Component {
  filledAmount: number;
}

const Root = styled.div<{$filledAmount: number}>`
    ${({$filledAmount}) => css`
        width: 50px;
        height: 20px;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        background: linear-gradient(
        90deg,
        #f5a74c 4.55%, /* Gradient part */
        #4dcd77 ${$filledAmount}%, /* Gradient part */
        #d3d3d3 ${$filledAmount}% 100% /* Grey part */
        );
    `}`;

const Indicator = ({ filledAmount, className }: ComponentProps) => <Root className={className} $filledAmount={filledAmount}/>;

export default Indicator;
